import { createFileRoute } from "@tanstack/react-router"

import { MyFilesPanel } from "@/pages/MyFilesPanel"

export const Route = createFileRoute("/operations/my-files")({
  component: MyFilesPanel,
})
